import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  HostListener,
  inject,
  input,
  OnDestroy,
  OnInit,
  Optional,
  output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { WindowHelper } from '@shared/helpers/window.helper';
import { Languages } from '@core/services/language.service';
import { debounce } from '@shared/decorators/debounce.decorator';
import { ListEvent, ListEventType } from '@shared/modules/list/model/list-event.model';
import { ListService } from '@shared/modules/list/services/list.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'list-search',
  templateUrl: './list-search.component.html',
  styleUrls: ['./list-search.component.scss']
})
export class ListSearchComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  WindowHelper = WindowHelper;
  Languages = Languages;

  private subject: Subject<string> = new Subject();
  private destroy$: Subject<void> = new Subject<void>();

  form: UntypedFormGroup;

  searchName = input<string>('');
  ignoreListSearch = input<boolean>(false);

  onQueryChange = output<string>();

  @HostListener('window:resize')
  @debounce(50)
  resize() {
    this.changes.detectChanges();
  }

  constructor(
    @Optional() private service: ListService,
    private changes: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.debounceSearch();
    this.listenQueryParams();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  debounceSearch() {
    this.subject
      .pipe(
        debounceTime(500),
        tap(() => {
          const query = this.form.get('search').value;
          this.onQueryChange.emit(query);

          if (this.ignoreListSearch()) return;
          if (!this.service) return;

          this.service.setSearch(query);
        })
      )
      .subscribe();
  }

  listenQueryParams() {
    if (!this.service) return;

    this.service.eventEmitter.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e: ListEvent<any>) => {
      if (e.type === ListEventType.QUERY_PARAMS && e.data.search) {
        this.form.get('search').setValue(e.data.search);
      }
    });
  }

  createForm() {
    this.form = new UntypedFormGroup({
      search: new UntypedFormControl('')
    });

    this.service?._search?.length ? this.form.get('search').setValue(this.service._search) : null;
  }

  onChange() {
    this.subject.next('');
  }
}
